import type { Security } from '@ipfabric/utils';
import { maybeProp } from '@ipfabric/utils/fp/prop';
import { getSecurityMachineFunctionByType } from 'components/SecuritySchema/helpers/getSecurityMachineFunctionByType';
import type { RuleChainScope } from 'components/SecuritySchema/model/SecuritySchemaScope';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { Draft } from 'immer';

export const getRuleChain: {
  (
    scope: RuleChainScope,
  ): (deviceSecurity: Security.DeviceSecurity) => Security.RuleChain | null;
  (
    scope: RuleChainScope,
  ): (
    deviceSecurity: Draft<Security.DeviceSecurity>,
  ) => Draft<Security.RuleChain> | null;
} = (scope: RuleChainScope) => (deviceSecurity: Security.DeviceSecurity) =>
  pipe(
    deviceSecurity,
    getSecurityMachineFunctionByType[scope.securityType],
    maybeProp('ruleChains', scope.name),
    option.toNullable,
  );
